import { getRuntimeEnv } from "./runtimeConfig";

const TRUTHY = new Set(["true", "1", "on", "yes"]);
const FALSY = new Set(["false", "0", "off", "no"]);

export const readBooleanEnv = (raw, defaultValue = true) => {
  const value = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (TRUTHY.has(value)) return true;
  if (FALSY.has(value)) return false;
  return defaultValue;
};

export const isFeatureEnabled = (name, defaultValue = true) =>
  readBooleanEnv(getRuntimeEnv(`REACT_APP_ENABLE_${name}`), defaultValue);
